import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Button } from '../ui/Button';

interface Props {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  rows?: number;
}

export function MarkdownEditor({ value, onChange, label, rows = 5 }: Props) {
  const [preview, setPreview] = useState(false);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.375rem' }}>
        {label && (
          <label style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)', fontWeight: 600 }}>
            {label}
          </label>
        )}
        <Button
          variant="ghost"
          size="sm"
          type="button"
          onClick={() => setPreview(p => !p)}
        >
          {preview ? 'Modifica' : 'Anteprima'}
        </Button>
      </div>

      {preview ? (
        <div
          style={{
            minHeight: rows * 24,
            padding: '0.5rem 0.75rem',
            background: 'var(--glass-bg-card)',
            border: '1px solid rgba(255,255,255,0.10)',
            borderRadius: 'var(--radius-card)',
            fontSize: 'var(--text-sm)',
            color: 'var(--color-text)',
            lineHeight: 1.6,
          }}
        >
          {value ? (
            <ReactMarkdown>{value}</ReactMarkdown>
          ) : (
            <span style={{ color: 'var(--color-text-faint)', fontStyle: 'italic' }}>Nessuna nota</span>
          )}
        </div>
      ) : (
        <textarea
          value={value}
          onChange={e => onChange(e.target.value)}
          rows={rows}
          style={{
            width: '100%',
            background: 'var(--glass-bg-card)',
            border: '1px solid rgba(255,255,255,0.10)',
            borderRadius: 'var(--radius-card)',
            color: 'var(--color-text)',
            fontSize: 'var(--text-sm)',
            fontFamily: 'var(--font-mono, monospace)',
            padding: '0.5rem 0.75rem',
            resize: 'vertical',
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      )}
    </div>
  );
}
